import React, { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import {
  WHATSAPP_DISPLAY,
  buildWhatsAppLink,
  DEFAULT_WA_MESSAGE,
} from "../lib/constants";

const NAV_LINKS = [
  { href: "#hero", label: "الرئيسية" },
  { href: "#paths", label: "الخدمات" },
  { href: "#offers", label: "الاستشارة" },
  { href: "#offers", label: "الدعم الكامل" },
  { href: "#faq", label: "الأسئلة" },
  { href: "#contact", label: "تواصل" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            handleNav("#hero");
          }}
          className="flex items-center gap-2"
          data-testid="logo-link"
        >
          <span className="font-tajawal text-2xl font-extrabold text-slate-900 tracking-tight">
            iqama<span className="text-emerald-600">.pl</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((link, i) => (
            <a
              key={`${link.href}-${i}`}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNav(link.href);
              }}
              className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-emerald-700 transition-colors"
              data-testid={`nav-link-${i}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={buildWhatsAppLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white font-medium rounded-xl px-4 py-2 text-sm transition-colors shadow-sm"
            data-testid="header-whatsapp-btn"
          >
            <MessageCircle className="w-4 h-4" />
            <span>واتساب</span>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-xl border border-slate-200 text-slate-700"
            aria-label="فتح القائمة"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-slate-200 bg-white"
          data-testid="mobile-nav"
        >
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV_LINKS.map((link, i) => (
              <a
                key={`m-${link.href}-${i}`}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.href);
                }}
                className="px-3 py-3 text-base font-medium text-slate-800 hover:bg-slate-50 rounded-lg text-start"
                data-testid={`mobile-nav-link-${i}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={buildWhatsAppLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white font-medium rounded-xl px-4 py-3 transition-colors"
              data-testid="mobile-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              <span>
                واتساب · <bdi dir="ltr">{WHATSAPP_DISPLAY}</bdi>
              </span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
